import { useEffect, useState } from "react";
import { Alert, Fade } from "react-bootstrap";
import { Col, Modal, Row } from "react-bootstrap"
import DefaultButton from "../../../../../components/buttons/default-button/DefaultButton";

interface tokenModalProps {
    visible: boolean
    onHide: () => void
    token: string
}

function TokenModal({ visible, onHide, token }: tokenModalProps) {
    const [showSuccess, setShowSucces] = useState(false)
    const [showFull, setShowFull] = useState(false);
    const safeToken = token ?? "";
    const shortToken =
        safeToken.length > 40
            ? `${safeToken.slice(0, 20)}...${safeToken.slice(-10)}`
            : safeToken;

    useEffect(() => {
        let throttle: string | number | NodeJS.Timeout | undefined

        if(showSuccess) {
            throttle = setTimeout(() => {
                setShowSucces(false)
            }, 1000)
        }

        return(() => {
            clearTimeout(throttle)
        })
    }, [ showSuccess ])

    return (
        <Modal
            show={visible}
            onHide={onHide}
            fullscreen="md-down"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center">
                    Generált token
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div
                    className="bg-light border rounded p-3"
                    style={{
                        fontFamily: "monospace",
                        overflowWrap: "anywhere",
                        wordBreak: "break-word"
                    }}
                >
                    {safeToken
                        ? (showFull ? safeToken : shortToken)
                        : "Nincs token"}
                </div>

                <Row style={{ textAlign: "center", marginTop: "10px" }}>
                    <Col>
                        <DefaultButton title={showFull ? "Rövidítés" : "Teljes token"} onClick={e => {
                            e.preventDefault()
                            setShowFull(!showFull)
                        }} />
                    </Col>

                    <Col>
                        <DefaultButton title={"Token másolása"} onClick={e => {
                            e.preventDefault()
                            navigator.clipboard.writeText(token)
                            setShowSucces(true)
                        }} />
                    </Col>
                </Row>

                <Alert style={{marginTop: "10px"}} show={showSuccess} transition={Fade} key={token} variant={"success"}>
                    Sikeresen másolva a vágólapra!
                </Alert>
            </Modal.Body>
        </Modal>
    );
}

export default TokenModal;